import Lottie from "lottie-react";
import { Link } from "react-router-dom";
import emptymylearning from "../../Assets/icons/emptymylearning.json";

const EmptyMyWishlist = () => {
  return (
    <div className="emptymylearning-courses d-flex flex-column justify-content-center align-items-center p-2">
      <Lottie
        animationData={emptymylearning}
        loop
        autoplay
        style={{ width: 280 }}
      />
      <p className="mt-3 fw-bold">
        Start learning from over 213,000 courses today.
      </p>
      <p>
        When you wishlist in a course, it will appear here.
        <Link className="fw-bold pb-1" to="/">
          Browse now
        </Link>
        .
      </p>
    </div>
  );
};

export default EmptyMyWishlist;
